import * as types from '../../actions/ActionTypes.js';

const initialState = {
    isFetching: false,
    entities: []
};

const validateDeviceHeartRate = (state = initialState, action) => {
    switch (action.type) {
        case types.REQUEST_VALIDATE_DEVICE_HEART_RATE:
            return {
                ...initialState,
                isFetching: true
            };
        case types.RECEIVE_VALIDATE_DEVICE_HEART_RATE:
            return {
                ...state,
                isFetching: false,
                entities: [...state.entities, action.validateDeviceHeartRate],
                lastUpdated: action.receivedAt
            };
        default:
            return state;
    }
};

export const getValidateDeviceHeartRate = (state) => state.validateDeviceHeartRate.entities;

export default validateDeviceHeartRate;
